export default {
      id: "svg-icon-like-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-like",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/like.svg
// module id = 2Dax
// module chunks = 4